import { TYPES } from "../Constants/history";

export const formatType = (value) => {
  if (value === TYPES.PAY) return "PAY";
  else if (value === TYPES.DISTRIBUTION) return "DISTRIBUTION";
  else if (value === TYPES.NOCOUNT) return "NO COUNT";
  else if (value === TYPES.BUYBACK) return "BUY BACK";
};

export const formatDate = (value) => {
  const time = new Intl.DateTimeFormat("en-US", {
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date(value));
  const day = new Intl.DateTimeFormat("vi-VN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(value));
  return `${day}, ${time}`;
};

export const formatNumber = (number) => {
  return number.toLocaleString("vi-VN");
};

export const formatDay = (value) => {
  const day = new Intl.DateTimeFormat("vi-VN", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  }).format(new Date(value));
  return `${day}`;
};
